// extracted by mini-css-extract-plugin
export default {"caixona":"p2_caixona__tUwfb","caixa":"p2_caixa__+J-vD"};